//transfer this to constants folder

let pageKeys = {
    allocation: 'pg239fx1pwyb0wz',
    annualization: 'pg0dw44c7vel9',
    apps: 'po1heh1ek935wr',
    attendance_corrections: 'pg01xs1f2nro4',           
    attendance_corrections_team_approver: 'po1aiy33zslf2tw0',
    attendance_corrections_company_approver: 'pg01x2nrs1fdc5l',   
    attendance_upload: 'po2a3iaxy33f0xt',
    attendance_face_activation: 'pg032e6slvadr19',
    faceai_settings: 'pg032e6sdr1lva4',
    cash_advances: 'pgs5dtwes792afx',
    workdays: 'pg0ro3dypi4btu',
    company_account: 'p81v2unrhgmw7',
    company_workshiftplan: 'ctg38zp4behb446',
    company_attendance: 'pg1q1n6ds35dc5l',
    company_linked_account: 'paxhiay1e5wr35d',
    company_billing: 'pcb706787d0a0fe17b',
    cutoff: 'p80wn4o33ysmwcl',
    twozeroone_files: 'pg698c4d268b2d',
    employees: 'pg00891owfbf3d',
    hr201: 'pg698c4d268b2d',
    fiscal_periods: 'pg3g0o6ylutw',
    holidays: 'pg0ny27r803ts0',
    leave_types: 'pg0y2f0facki',
    loans: 'pgfadtwesd3452l',
    my_attendance: 'p8183psp23rbvli',
    my_workshifts: 'ior0740pg0fc35dr3',
    my_cash_advances: 'pgs79e579a9xa2dtw',
    mycalendar: 'pg0u3bfdpvkiyb',
    my_loans: 'pgs2390asdasa34d',
    manual_adjustments: 'pg050dp8xprhr',
    overtime: 'pg0fior07hhsedr3',
    overtime_team_approver: 'pg1xcshwz6hva',
    overtime_company_approver: 'p183spjj4kb7vli',
    paygrades: 'pg18citm5dwyu6',
    payroll: 'po281b2okg08hn',
    payroll_migration: 'pg2j70xlablyt37x',
    mypayslip: 'pg29b0xslh0u',
    projectcharges: 'pg3pubr2k0hmg',
    projectcharges_approver: 'pg1huyslm5rth',
    projects: 'pg0fyrisg1tw88m',
    project_reports: 'mpg1husmuar36',
    reimbursements: 'pg4a9xs45d90faw',
    myreimbursements: 'pgs72sdacad2af23',
    team_attendance: 'pg1qz2gkp1n6l',
    team_calendar: 'pg28umy2wyo1jg',
    teams: 'p81kel7dvdn7mqw',
    team_roles: 'acb4bee1bb3a184f',
    timeoff: 'p823tb2rr5jip43',
    timeoff_team_approver: 'pg3pyzuczhiatx',
    timeoff_company_approver: 'pg3pyz41hia5uc7',
    timesheet: 'pg39two8fxm0di6',
    timesheet_team_approver: 'pg3wm0o8f9txdxf5',
    timesheet_company_approver: 'pg39twm0dxfo8fx5',
    workshifts: 'pg1xh29a9rdgum',
    workshifts_assignment: 'pg3ctzh84beb4',
    workshifts_plan: 'ctzpg3hb484be46',
    sss: 'pg29b0x3xh0usl',
    pagibig: 'pg29b0h086ush',
    philhealth: 'pg2ju9b0h08cbf',
    reference_tables: 'pg2ju9b08cxlyt32v'
}

export default pageKeys